// CareerPage.jsx
import React, { useState, useEffect, Component } from "react";
import "./nav.css";
import SideNav from "./sidenav";
import "./Blog.css";
import BlogMobileNav from "./blogmobilenav";
import Men from "../images/bloginnerbg.jpg";
import Scnd from "../images/inner.jpg";
import board from "../images/coperate.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { GoDotFill } from "react-icons/go";
import { Link } from "react-router-dom";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import moment from 'moment';


const client = new ApolloClient({
  link: new HttpLink({ uri: "https://pensure-cms.inspireleadership.biz/graphql"}),
  cache: new InMemoryCache(),
});


export const downloadItems = [
  {
    id: 1,
    img: Men,
    title: "Cheers to Two Decades of Pension Reform Act 2024!",
    date: "January 15, 2025",
    readtime: "8min read",
    category: "News",
    paragraph1:
      "The Pension Reform Act 2004 has so far guaranteed timely retirement benefit payments, helped individuals save for old age, and established consistent standards for benefit administration and disbursement. ",
    paragraph2:
      "As we celebrate this incredible milestone as your pension fund administrator, we would like to take a moment to reflect on our journey in the industry.",
    paragraph3: "A Journey of Milestones",
    paragraph4:
      "From our modest start in 2004, Leadway Pensure has grown into a trusted name in the pension fund administration landscape with a series of groundbreaking achievements. Established to provide unparalleled pension fund administration services in Nigeria, Leadway Pensure became one of the first pension fund administrators under the Pension Reform Act, offering comprehensive pension management services. Over the years, we achieved significant growth in assets and an increased enrollee base, surpassing major milestones in assets under management. We marked our anniversary with a substantial number of enrollees and attained significant advancements in our digital service offerings, reflecting our ongoing commitment to excellence and an expanding client base",
    paragraph5:
      "We should not forget the remarkable accolades we have received over the years as we dauntingly take on the responsibility of ensuring your post-productive years count, ensuring you “live your best life” yet.",
    paragraph6: "A Heartfelt Thank You – You Made it Possible",
    paragraph7:
      "We owe our success to the tenacious support of our partners, enrollees, investors, and other stakeholders. Your loyalty and trust in our services have been the cornerstone of our achievements and growth. Thank you for your continued partnership and confidence in our vision. We are excited to share this moment with you",
    pargraph8: "Looking Ahead",
    paragraph9:
      "As we gaze into the future, we remain committed to pushing the boundaries of excellence and innovation to better serve you. The next decade promises even greater advancements as we continue to enhance our services, embrace cutting-edge technology, and expand our reach",
    scndimg: Scnd,
  },
  {
    id: 2,
    img: board,
    title: "Cheers to Two Decades of Pension Reform Act 2024",
    date: "January 15, 2025",
    readtime: "8min read",
    category: "News",
  },
  {
    id: 3,
    img: Men,
    title: "Cheers to Two Decades of Pension Reform Act 2024",
    date: "January 15, 2025",
    readtime: "8min read",
    category: "News",
  },
  {
    id: 4,
    img: board,
    title: "Cheers to Two Decades of Pension Reform Act 2024",
    date: "January 15, 2025",
    readtime: "8min read",
    category: "News",
  },
  {
    id: 5,
    img: Men,
    title: "Cheers to Two Decades of Pension Reform Act 2024",
    date: "January 15, 2025",
    readtime: "8min read",
    category: "News",
  },
  {
    id: 6,
    img: board,
    title: "Cheers to Two Decades of Pension Reform Act 2024",
    date: "January 15, 2025",
    readtime: "8min read",
    category: "News",
  },
];









const Blog = () => {

   window.scrollTo(0, 0)

const[allBlogContent, setAllBlogContent] = useState([])

  useEffect( () => {
  
  client
    .query({
      query: gql`
    query NewQuery {
blog {
    edges {
      node {
      id
        categories {
          nodes {
            databaseId
            name
            
          }
        }
        blogs {
          body {
            contentarea
            image {
              mediaItemUrl
            }
            list {
              items
              images {
                mediaItemUrl
              }
            }
            subheading
            text
            textcontent
          }
          coverImage {
            mediaItemUrl
          }
          heading
        }
        date
      }
    }
  }
  }
      `,
    })
    .then((result) => {
  
       console.log(result.data.blog)
       setAllBlogContent(result.data.blog.edges)
          
  
  
  
  
    });
  
  }, [])  
  

  const [active, setActive] = useState("ALL");

  const menuItems = ["ALL", "NEWS", "ARTICLES", "CAREER INSIGHTS"];


   const savedItems = allBlogContent.map((item) => {
  
    return (
      <Link
        to={`/blog-single/${item.node.id}`}
        key={item.node.blogs.id}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div id="blog-crd" className=" crd card " style={{ width: "311px" }}>
          <div style={{ padding: "0.64rem" }}>
            <div
              className="card-img-top "
              style={{
                height: "240px",
                borderRadius: "0.5rem", // keep rounded edges
                backgroundImage: `url(${item.node.blogs.coverImage.mediaItemUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
          </div>

          <div className="card-body">
            <h5
              className="card-title crd-ttl "
              style={{ fontSize: "1.20rem !important", fontWeight: "400" }}
            >
              {item.node.blogs.heading}
            </h5>
            <p className="card-text crd-txt mt-2" style={{ fontWeight: "450" }}>
              {moment(item.node.date).format("MMM Do YYYY")}
              <GoDotFill className="ms-1 me-1" style={{ fontSize: "8px" }} />
                {item.node.categories.nodes[0].name}
              <GoDotFill className="ms-1 me-1" style={{ fontSize: "8px" }} />
         
            </p>
            <hr
              style={{
                border: "0",
                borderTop: "2px dashed #e9e8e8ff",
                borderImage:
                  "repeating-linear-gradient(to right, #d1cfcfff 0, #d1cfcfff 4px, transparent 4px, transparent 8px) 1",
              }}
            />
            <div className="Read-more d-flex align-items-center">
              <FontAwesomeIcon
                className="chv-dwn-arr "
                icon={faArrowRight}
                style={{
                  color: "#fe7914",
                  fontSize: "8px",
                  fontWeight: "light",
                  backgroundColor: "#FFEACC",
                  padding: "13.5px",
                }}
              />{" "}
              <span class=" ms-2" style={{ fontWeight: "500" }}>
                {" "}
                Read More{" "}
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  });


   const savedArticleItems = allBlogContent.map((item) => {
    if(item.node.categories.nodes[0].name === 'Articles')
    return (
      <Link
        to={`/blog-single/${item.node.id}`}
        key={item.node.blogs.id}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div id="blog-crd" className=" crd card " style={{ width: "311px" }}>
          <div style={{ padding: "0.64rem" }}>
            <div
              className="card-img-top "
              style={{
                height: "240px",
                borderRadius: "0.5rem", // keep rounded edges
                backgroundImage: `url(${item.node.blogs.coverImage.mediaItemUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
          </div>

          <div className="card-body">
            <h5
              className="card-title crd-ttl "
              style={{ fontSize: "1.20rem !important", fontWeight: "400" }}
            >
              {item.node.blogs.heading}
            </h5>
            <p className="card-text crd-txt mt-2" style={{ fontWeight: "450" }}>
              {moment(item.node.date).format("MMM Do YYYY")}
              <GoDotFill className="ms-1 me-1" style={{ fontSize: "8px" }} />
                {item.node.categories.nodes[0].name}
              <GoDotFill className="ms-1 me-1" style={{ fontSize: "8px" }} />
         
            </p>
            <hr
              style={{
                border: "0",
                borderTop: "2px dashed #e9e8e8ff",
                borderImage:
                  "repeating-linear-gradient(to right, #d1cfcfff 0, #d1cfcfff 4px, transparent 4px, transparent 8px) 1",
              }}
            />
            <div className="Read-more d-flex align-items-center">
              <FontAwesomeIcon
                className="chv-dwn-arr "
                icon={faArrowRight}
                style={{
                  color: "#fe7914",
                  fontSize: "8px",
                  fontWeight: "light",
                  backgroundColor: "#FFEACC",
                  padding: "13.5px",
                }}
              />{" "}
              <span class=" ms-2" style={{ fontWeight: "500" }}>
                {" "}
                Read More{" "}
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  });


   const savedCareerItems = allBlogContent.map((item) => {
    if(item.node.categories.nodes[0].name === 'Career Insights')
    return (
      <Link
        to={`/blog-single/${item.node.id}`}
        key={item.node.blogs.id}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div id="blog-crd" className=" crd card " style={{ width: "311px" }}>
          <div style={{ padding: "0.64rem" }}>
            <div
              className="card-img-top "
              style={{
                height: "240px",
                borderRadius: "0.5rem", // keep rounded edges
                backgroundImage: `url(${item.node.blogs.coverImage.mediaItemUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
          </div>

          <div className="card-body">
            <h5
              className="card-title crd-ttl "
              style={{ fontSize: "1.20rem !important", fontWeight: "400" }}
            >
              {item.node.blogs.heading}
            </h5>
            <p className="card-text crd-txt mt-2" style={{ fontWeight: "450" }}>
              {moment(item.node.date).format("MMM Do YYYY")}
              <GoDotFill className="ms-1 me-1" style={{ fontSize: "8px" }} />
                {item.node.categories.nodes[0].name}
              <GoDotFill className="ms-1 me-1" style={{ fontSize: "8px" }} />
         
            </p>
            <hr
              style={{
                border: "0",
                borderTop: "2px dashed #e9e8e8ff",
                borderImage:
                  "repeating-linear-gradient(to right, #d1cfcfff 0, #d1cfcfff 4px, transparent 4px, transparent 8px) 1",
              }}
            />
            <div className="Read-more d-flex align-items-center">
              <FontAwesomeIcon
                className="chv-dwn-arr "
                icon={faArrowRight}
                style={{
                  color: "#fe7914",
                  fontSize: "8px",
                  fontWeight: "light",
                  backgroundColor: "#FFEACC",
                  padding: "13.5px",
                }}
              />{" "}
              <span class=" ms-2" style={{ fontWeight: "500" }}>
                {" "}
                Read More{" "}
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  });

  const savedNewsItems = allBlogContent.map((item) => {
    if(item.node.categories.nodes[0].name === 'News')
    return (
      <Link
        to={`/blog-single/${item.node.id}`}
        key={item.node.blogs.id}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div id="blog-crd" className=" crd card " style={{ width: "311px" }}>
          <div style={{ padding: "0.64rem" }}>
            <div
              className="card-img-top "
              style={{
                height: "240px",
                borderRadius: "0.5rem", // keep rounded edges
                backgroundImage: `url(${item.node.blogs.coverImage.mediaItemUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
          </div>

          <div className="card-body">
            <h5
              className="card-title crd-ttl "
              style={{ fontSize: "1.20rem !important", fontWeight: "400" }}
            >
              {item.node.blogs.heading}
            </h5>
            <p className="card-text crd-txt mt-2" style={{ fontWeight: "450" }}>
              {moment(item.node.date).format("MMM Do YYYY")}
              <GoDotFill className="ms-1 me-1" style={{ fontSize: "8px" }} />
                {item.node.categories.nodes[0].name}
              <GoDotFill className="ms-1 me-1" style={{ fontSize: "8px" }} />
         
            </p>
            <hr
              style={{
                border: "0",
                borderTop: "2px dashed #e9e8e8ff",
                borderImage:
                  "repeating-linear-gradient(to right, #d1cfcfff 0, #d1cfcfff 4px, transparent 4px, transparent 8px) 1",
              }}
            />
            <div className="Read-more d-flex align-items-center">
              <FontAwesomeIcon
                className="chv-dwn-arr "
                icon={faArrowRight}
                style={{
                  color: "#fe7914",
                  fontSize: "8px",
                  fontWeight: "light",
                  backgroundColor: "#FFEACC",
                  padding: "13.5px",
                }}
              />{" "}
              <span class=" ms-2" style={{ fontWeight: "500" }}>
                {" "}
                Read More{" "}
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  });

  return (
    <div
      id="containeer-blog"
      class=" d-flex align-items-start  mt-4"
      style={{ backgroundColor: "none" }}
    >
      <div className="side-blog">
        <SideNav
          items={menuItems}
          activeItem={active}
          onSelect={setActive}
          funds={false}
          className={"blog-side-nav desktop-only"}
        />

        <BlogMobileNav
          items={menuItems}
          activeItem={active}
          onSelect={setActive}
        />

        <div className="rght-side-blog flex-1 p-6">
          {active === "ALL" && (

              
            <div className="crd-div-1 d-flex flex-wrap row-gap-5">

              
              {savedItems}
            </div>
                 
                
    
          )}
     {active === "NEWS" && (
      <div className="crd-div-1 d-flex flex-wrap row-gap-5">
      {savedNewsItems}
      </div>
          )}
          {active === "ARTICLES" && (
            <div className="crd-div-1 d-flex flex-wrap row-gap-5">
              {savedArticleItems}
            </div>
          )}
          {active === "CAREER INSIGHTS" && (
            <div className="crd-div-1 d-flex flex-wrap row-gap-5">
              {savedCareerItems}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Blog;
